import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import compareDesc from 'date-fns/compareDesc';
import Tags from '@/components/Tags';
import { CustomerNoteModel, CustomerTagModel } from '@/models/customer';
import { TagType } from '@/models/tag';
import { TagProps } from '@/components/Tag';

const useStyles = makeStyles(() => ({
	classificationNote: {
		marginTop: '10px',
	},
}));

interface Props {
	customerNotes: CustomerNoteModel[]
	customerTags?: CustomerTagModel[]
}

export const HeaderCustomerNote = ({ customerNotes, customerTags }: Props) => {
	const [tags, setTags] = React.useState<TagProps[]>([]);
	const [latestNote, setLatestNote] = React.useState<CustomerNoteModel | null>(null);
	const classes = useStyles();

	useEffect(() => {
		if (customerTags !== undefined) {
			const foundTags = new Map<string, TagProps>();

			customerTags.forEach(({ tag }) => {
				if (tag !== undefined && tag.type === TagType.CLASSIFICATION && foundTags.has(tag.id) === false) {
					foundTags.set(tag.id, {
						label: tag.label,
					});
				}
			});

			setTags(Array.from(foundTags.values()));
		}
	}, [customerTags]);

	useEffect(() => {
		const sortedNotes = customerNotes
			.filter(
				note => note.customerNoteTags?.filter(
					tag => tag.tag?.type === TagType.CLASSIFICATION
				)
			)
			.sort((noteA, noteB) => compareDesc(new Date(noteA.createdAt), new Date(noteB.createdAt)));

		setLatestNote(sortedNotes[0] ?? null);
	}, [customerNotes]);

	return (
		<div data-id={`header-customer-note-${latestNote?.id}`}>
			<Tags tags={tags} />

			{latestNote && (
				<div className={classes.classificationNote}>
					{latestNote.content}
				</div>
			)}
		</div>
	);
}
